<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    browser: 'browser',
  }),

  data() {
    return {
      isIE11: false,
    };
  },

  mounted() {
    this.isIE11 = this.browser.indexOf('ie') > -1 || window.innerWidth < 500;
  },
};
</script>



// WEBPACK FOOTER //
// src/mixins/IEDetector.vue